import {
  Control,
  Controller,
  FieldValues,
  useFieldArray,
  UseFormClearErrors,
} from 'react-hook-form';
import Input from 'src/components/Input/Input';
import type { FreshdeskHelpCenterFormValues } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateFreshdeskIntegrationPopup/FreshdeskIntegrationForm2/freshdeskHelpCenterFormValues';

const CloseIcon = ({ onClick = () => {} }: { onClick?: () => void }) => {
  return (
    <button type="button" aria-label="Remove URL" onClick={onClick} className={'cursor-pointer'}>
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
        <path d="M1 0.5L9 8.5M9 0.5L1 8.5" stroke="#E50505" strokeLinecap="round" />
      </svg>
    </button>
  );
};

export const FreshdeskHelpCenterExcludedUrls = ({
  control,
  clearErrors = () => {},
}: {
  control: Control<FreshdeskHelpCenterFormValues>;
  clearErrors?: UseFormClearErrors<FreshdeskHelpCenterFormValues>;
}) => {
  // react-hook-form types field arrays as arrays of objects; this holds plain URL strings.
  const { fields, append, remove } = useFieldArray({
    control: control as unknown as Control<FieldValues>,
    name: 'excluded_articles',
  });

  return (
    <div className={'flex flex-col w-full gap-2.5 p-2.5'}>
      {Boolean(fields.length) && (
        <ul className={'flex flex-col w-full gap-2.5'}>
          {fields.map((item, index) => (
            <li key={item.id} className={'flex flex-col w-full gap-[5px]'}>
              <div>
                <p
                  className={
                    'text-xs text-ebony_opacity_50 font-medium flex flex-row items-center justify-between'
                  }
                >
                  <span>{index + 1}. Excluded Url</span>
                  {<CloseIcon onClick={() => remove(index)} />}
                </p>
              </div>
              <div>
                <Controller
                  control={control}
                  name={`excluded_articles.${index}`}
                  render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <Input
                      type={'text'}
                      placeholder={'https://www'}
                      invalidMessage={error?.message}
                      value={value}
                      isValid={!error?.message}
                      onChange={onChange}
                      onFocus={() => {
                        clearErrors(`excluded_articles.${index}`);
                      }}
                      className={'!py-2 !px-3.5'}
                    />
                  )}
                />
              </div>
            </li>
          ))}
        </ul>
      )}
      <button
        type="button"
        onClick={() => append('')}
        className={'text-[#7A6BE5] text-xs font-medium cursor-pointer hover:underline text-left'}
      >
        Exclude specific article
      </button>
    </div>
  );
};
